export const SLIDERS_ENUM = {
  POPULAR_DREAM: "Popular Dream",
  TODAYS_BIRTHDAY: "This Month's Birthdays",
  DREAM_MAKERS: "Dream Makers",
  TOP_DONORS: "Top Donors This Month",
  NEW_DREAMS: "New Dreams",
  WING_PAGE: "Wing Makers",
  ANGEL_PAGE: "Fulfilled Dreams",
};
